export const settingsTheme = {
  examples: {
    container: {
      bg: 'palette.surface.2',
      borderRadius: '12px',
    },
    surfacePreview: {
      bg1: 'palette.surface.1',
      bg2: 'palette.surface.2',
      bg3: 'palette.surface.3',
      bg4: 'palette.surface.4',
      bg5: 'palette.surface.5',
      name: 'palette.tertiary.50',
    },
    title: 'palette.tertiary.90',
  },
  sidebar: {
    bg: 'palette.surface.2',
    borderRadius: '12px',
    presets: {
      borderColor: 'palette.surface.5',
      borderWidth: '1px',
      colorPicker: {
        borderColor: 'palette.surface.5',
        borderWidth: '1px',
        icon: 'palette.tertiary.60',
        title: 'palette.tertiary.60',
      },
      subtitle: 'palette.tertiary.90',
      title: 'palette.tertiary.90',
    },
    tertiaryWarn: {
      bg: 'palette.warning.30:0.1',
      borderColor: 'palette.warning.30',
      borderRadius: '8px',
      borderWidth: '1px',
      text: 'palette.warning.70',
    },
    title: 'palette.tertiary.90',
  },
  title: 'palette.tertiary.90',
};
